<template>
<main role="main" class="container">
	<div class="row">
		<div class="col-md-12 text-left main-desc">
			なにもないから n/a。mammoniteはメマーナイトと読みましょう。
		</div>
	</div>
	<div class="row">
		<div class="col-md-6 text-left">
			<ul>
				<li>[RO] ネイチャ計算機(停止)</li>
				<li>[RO] オーク記憶成果アプリ(停止)</li>
				<li><a href="http://sns.gungho.jp/ro/?m=pc&a=page_f_home&target_c_member_id=19345">[RO] SNS</a></li>
				<li><a href="http://www.nicovideo.jp/user/704990">ニコニコマイページ</a></li>
				<li><a href="https://twitter.com/nac_web">ツイッター</a></li>
				<li><a href="http://tumblr.mammonite.com/">tumblr</a></li>
				<li><a href="http://www.lastfm.jp/user/nac_web?setlang=jp">lastfm</a></li>
			</ul>
		</div>
		<div class="col-md-6 text-left">
			<ul>
				<li>2019-05-13 vue.js</li>
				<li>2017-01-25 AWS移管、S3ホスティング(https)</li>
				<li>2016-03-17 Let's Encryptをお試し</li>
				<li>2015-02-01 さくらVPS(512)をお試し</li>
				<li>2014-05-30 xreaから一旦退避</li>
				<li>2014-03-22 appのサーバーをnginx化で一時閉鎖</li>
				<li>2014-03-22 0chをtumblrに移行</li>
				<li>2012-12-21 ROのRR化に伴い旧仕様計算機の閉鎖</li>
				<li>2012-12-20 裏回りをCodeIgniterに変更</li>
				<li>2012-12-19 sticky footer化</li>
				<li>2012-08-12 bootstrapでデザイン設置</li>
				<li>2012-03-26 twitter取得</li>
				<li>2012-03-08 HTML5に変更</li>
				<li>2011-12-06 googleのwiki機能をリンク追加(→PG的メモ)</li>
				<li>2011-11-11 googleのブログ機能を自ドメインに設定</li>
				<li>2011-10-29 googleのブログ機能へブログ移行</li>
			</ul>
		</div>
	</div>
	<div class="row">
		<div class="col-md-12 text-left">
			since 1998-{{ ymd }} Nac.
		</div>
	</div>
</main>
</template>

<script>
export default {
  name: 'top_main',
  data () {
    return {
      ymd: (new Date()).getFullYear()
    }
  }
}
</script>

<style scoped>
main {
  margin-top: 4rem;
}
.main-desc {
	padding: 1rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/top/Main.vue